export default "__VITE_ASSET__B4Y1eYon__"